import { useState } from "react";
import { getAPIFromDomain } from "lib/api";

export const useProductsCSVUpload = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [timeoutError, setTimeoutError] = useState("");

  const api = getAPIFromDomain("fulfillment");
  const url = "/products/csv_upload";

  const uploadProductsCSV = (organizationID: string, file: File): any => {
    setLoading(true);
    setData(undefined);
    setErrors([]);
    setTimeoutError("");

    const formData = new FormData();
    formData.set("product[organization_id]", organizationID);
    formData.set("product[file]", file);

    return api
      .post(url, formData, {
        transformResponse: (res: any) => {
          let responseData;
          try {
            responseData = JSON.parse(res);
            const keys = Object.keys(responseData);
            const hasError = keys.some((k) => k.includes("error"));
            if (hasError) {
              setErrors(responseData?.errors?.lines_with_errors || [responseData?.error_message]);
              return false;
            }
            setData(responseData);
            return responseData;
          } catch (_) {
            setErrors(["Oops, something went wrong. Please try again."]);
          } finally {
            setLoading(false);
          }
        },
      })
      .catch((e) => {
        if (e === "error receiving data") {
          setTimeoutError(
            "Request timeout. We are processing the data in the background, please check your products later."
          );
        }
        setLoading(false);
      });
  };

  const productsCSV = { data, loading, errors, timeoutError };
  return { productsCSV, uploadProductsCSV };
};
